<template>
    <v-dialog v-model="value" scrollable persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly">
        <v-card>
            <v-toolbar dark color="primary">
                <v-toolbar-title>{{$t('event.media')}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="$emit('input', false)">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider />
            <v-card-text id="media-picker-scroll-target">

                <v-layout>
                    <v-flex xs7 class="mr-2">
                        <v-text-field
                                @input="searchMedia"
                                :label="$t('action.search')"
                                v-model="search"
                                clearable
                                clear-icon="close"
                                append-icon="search"
                                :loading="searching"
                        >
                        </v-text-field>
                    </v-flex>
                    <v-flex xs5 d-flex>
                        <v-select
                                @change="searchMedia(search)"
                                :items="sorting_items"
                                v-model="sort_by"
                                name="sort_by"
                                item-text="name"
                                item-value="value"
                                :label="$t('general.sort_by')"
                        ></v-select>
                    </v-flex>
                </v-layout>


                <v-layout v-scroll:#media-picker-scroll-target="onScroll" text-xs-center>
                    <v-flex xs12>

                        <v-layout row wrap>
                            <template v-for="m in media">
                                <v-flex
                                        :key="m.id"
                                        xs4
                                        d-flex
                                >
                                    <v-card flat tile class="d-flex pa-1 ">
                                        <v-checkbox
                                                v-model="m.selected"
                                                style="width: 100%"
                                                class="image-selector mt-0"
                                        >
                                            <div slot="label" style="width: 100%;">
                                                <v-img
                                                        :src="getMediaThumbnail(m.file.absolute_url)"
                                                        aspect-ratio="1"
                                                        class="grey lighten-2"
                                                ></v-img>
                                                <div class="font-weight-bold media-name">{{m.name}}</div>
                                            </div>
                                        </v-checkbox>

                                    </v-card>
                                </v-flex>
                            </template>
                        </v-layout>

                    </v-flex>
                </v-layout>
                <v-layout v-if="loading" text-xs-center>
                    <v-flex xs12>
                        <v-progress-circular
                                indeterminate
                                color="primary"
                        ></v-progress-circular>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions v-if="multipleSelect">
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="$emit('input', false)">{{$t('action.cancel')}}</v-btn>
                <v-btn color="blue darken-1" flat @click="returnMedias()">{{$t('action.confirm')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import RequestHandler from '~/utils/request-handler'
    import {UrlServices} from "~/utils/url-manager";
    import {CancelToken} from 'axios'
    import OssStyler from '~/utils/images/oss-styler'

    export default {
        name: "MediaPicker",
        props: {
            value: Boolean,         // Set true to show. Do NOT change this name so that we can use v-model in parent components
            title: String,          // Dialog title
            exclude: Array,         // Media to be exclude from the selection list
            eventId: Number,        // Get user media by event
            mediaType: Number,      // Get media by media type
            multipleSelect: {       // Set true to allow select multiple media
                type: Boolean,
                default: true
            },
            defaultSearchString: {
                type: String,
                default: ""
            }
        },
        data () {
            return {
                bottomReached: false,
                sort_by: "name_asc",
                sorting_items: [],
                page: 1,
                loading: true,
                media: [],
                search: '',
                searching: false,
                cancel: () => {},
            }
        },
        watch: {
            value: function(newValue) {
                if (newValue) {
                    if(this.defaultSearchString === ""){
                        this.search = '';
                    }else {
                        this.search = this.defaultSearchString;
                    }
                    this.bottomReached = false;
                    this.getMedia(this.search);
                } else {
                    // Reset data
                    this.page = 1;
                    this.loading = true;
                    this.media = [];
                }
            },
        },
        created() {
            let me = this;
            let sorting_item_values = ['name_asc', 'name_desc', 'created_time_asc', 'created_time_desc'];
            _.each(sorting_item_values, function(value){
                me.sorting_items.push({
                    'name': me.$t('media_sorting_item.' + value),
                    'value': value
                });
            });
        },
        methods: {
            getMedia: _.debounce(function(search) {
                let me = this;

                let config = {
                    cancelToken: new CancelToken(function executor(c){
                        me.cancel = c;
                    })
                };

                let params = {
                    page: me.page,
                    search: search,
                    event: me.eventId,
                    excluded_media: me.exclude,
                    media_type: me.mediaType,
                    sort_by: me.sort_by
                };

                //TODO filter contacts when retrieving contacts from database intead of filtering from response data
                RequestHandler.Get(UrlServices.createUrl({'name': 'api_event_media_list'}), params, {
                    'success': function (data) {
                        console.log(data.data);

                        data.data.map(x => {
                            x.selected = false;  // By default select all contacts if event or group is specified
                        });

                        // data.data.map(x => {
                        //     x.selected = !!me.eventId || !!me.groupId;  // By default select all contacts if event or group is specified
                        //     formatter.parsePhone(x);
                        // });
                        // _.each(data.data, x => {
                        //     if (!_.some(me.exclude, {areaCode: x.areaCode, phone: x.phone}) && !_.some(me.contacts, {areaCode: x.areaCode, phone: x.phone})) {
                        //         me.contacts.push(x);
                        //     }
                        // });

                        _.each(data.data, x => {
                            if (!_.some(me.media, {id: x.id})) {
                                me.media.push(x);
                            }
                        });

                        me.loading = false;
                        me.searching = false;
                        if (me.page < data.total_page) {
                            me.bottomReached = false;
                        }
                        me.page++;
                    }
                }, config)

            }, 0),
            searchMedia: _.debounce(function(search){
                this.cancel();
                this.page = 1;
                this.searching = true;
                this.media = _.filter(this.media, x => {
                    return x.selected;
                });
                this.$nextTick(function() {
                    this.getMedia(search);
                });
            }, 500),
            returnMedias() {
                this.$emit('success', _.filter(this.media, x => {
                    return x.selected;
                }));
            },
            returnMedia(media) {
                this.$emit('success', media);
            },
            onScroll(e) {
                if ((e.target.offsetHeight + e.target.scrollTop) >= e.target.scrollHeight) {
                    // you're at the bottom of the page
                    if (!this.bottomReached) {
                        this.bottomReached = true;
                        this.loading = true;
                        this.getMedia(this.search);
                    }
                }
            },
            getMediaThumbnail(url) {
                return OssStyler.getThumbnailResUrl(url);
            },
        }
    }
</script>

<style>
    .image-selector .v-input--selection-controls__input {
        position: absolute;
        top: 5px;
        left: 5px;
        padding: 0 0 0 2px;
        z-index: 10;
        background-color: white;
    }

    .image-selector .v-messages {
        display: none;
    }

    .image-selector .v-input__control {
        width: 100%;
    }
    .image-selector .v-label {
        width: 100%;
    }

    .media-name {
        word-break: break-all;
    }
</style>